<script>
  import { getLoggedIn, getCartCount } from '../../../../../../js/stores';
  import { filterNavItems } from '../../../../../../js/navItemFilters';

  import Spotlight from '../../Spotlight/Spotlight.svelte';
  import SubcategoryFlattened from './SubcategoryFlattened/SubcategoryFlattened.svelte';

  const loggedInStore = getLoggedIn();
  const cartCountStore = getCartCount();

  export let navItems = [];
  export let spotlightConfig = undefined;

  $: filteredItems = filterNavItems({
    items: navItems,
    loggedIn: $loggedInStore,
    cartCount: $cartCountStore,
  });

  // Category list items should only be of type 'category'
  $: categoryItems = filteredItems.filter((item) => item.type === 'category');
</script>

<ul class="CategoryListFlattened">
  {#each categoryItems as item}
    <li class="category-item" class:hidden={item.hidden}>
      <SubcategoryFlattened id={item.id} title={item.title} navItems={item.navItems} />
    </li>
  {/each}
  {#if spotlightConfig}
    <li>
      <Spotlight id={spotlightConfig.id} title={spotlightConfig.title} items={spotlightConfig.items} />
    </li>
  {/if}
</ul>

<style>.CategoryListFlattened {
  display: block;
  box-sizing: border-box;
  padding: 0;
  margin: 0;
  list-style-type: none;
  position: relative;
  width: 100%;
  max-width: 1400px;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  gap: 22px;
  margin: 32px 32px 32px 24px;
  transition: min-height 250ms cubic-bezier(0.4, 0, 0.2, 1);
}
.CategoryListFlattened > li {
  display: block;
  position: static;
  box-sizing: border-box;
  margin: 0;
  padding: 0;
}
.CategoryListFlattened > li::before {
  display: none;
}

.category-item {
  width: 100%;
}</style>
